import { useState } from 'react';
import ModalWrapper from '../ModalWrapper';
import AiScan from './AiScan.png';
import styles from './AIAdvisorIntro.module.css';
import Button from '../../../shared/ui/button/button';
import { useIntl } from 'react-intl';

const totalSlides = 3;

export function AIAdvisorIntroContent({ onContinue, onSkip }) {
	const intl = useIntl();
	const [currentSlide] = useState(0);

	return (
		<div className={styles.modalCard}>
			<div className={styles.iconContainer}>
				<img src={AiScan} alt='AiScan' />
			</div>

			<h1 className={styles.title}>
				{intl.formatMessage({ id: 'AIAdvisorIntroId1' })}
			</h1>

			<p className={styles.description}>
				{intl.formatMessage({ id: 'AIAdvisorIntroId2' })}
			</p>

			<div className={styles.pagination}>
				{Array.from({ length: totalSlides }).map((_, index) => (
					<div
						key={index}
						className={`${styles.dot} ${
							index === currentSlide ? styles.activeDot : ''
						}`}
					/>
				))}
			</div>

			<Button fullWidth onClick={onContinue}>
				{intl.formatMessage({ id: 'AIAdvisorIntroId3' })}
			</Button>

			<Button variant='ghost' onClick={onSkip}>
				{intl.formatMessage({ id: 'AIAdvisorIntroId4' })}
			</Button>
		</div>
	);
}

const AIAdvisorIntro = ({ isOpen, onClose, onContinue }) => {
	const handleSkip = () => {
		if (onClose) onClose();
	};

	if (!isOpen) return null;

	return (
		<ModalWrapper isOpen={isOpen} onSkip={handleSkip}>
			<AIAdvisorIntroContent onContinue={onContinue} onSkip={handleSkip} />
		</ModalWrapper>
	);
};

export default AIAdvisorIntro;
